import { useLazyQuery, useQuery, gql } from "@apollo/client"

const USERS_QUERY = gql`
  query Users {
    users {
      id
      firstName
      lastName
      fullName
      avatar {
        key
      }
      locations {
        id
        name
      }
    }
  }
`

const useQueryUsers = () => useQuery(USERS_QUERY)

const useLazyQueryUsers = () => useLazyQuery(USERS_QUERY)

export { useQueryUsers, useLazyQueryUsers }
